import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const FeatureHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5 py-16 md:py-20 lg:py-24">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-2xl bg-primary/10 mb-6 md:mb-8">
            <Icon name="Sparkles" size={40} color="var(--color-primary)" strokeWidth={2} />
          </div>
          
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 md:mb-6">
            Powerful Features for Modern Retail
          </h1>
          
          <p className="font-body text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto">
            Discover comprehensive tools designed to streamline your retail operations, from inventory management to customer loyalty programs. Everything you need to grow your business.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FeatureHero;